// extracted by mini-css-extract-plugin
module.exports = {"autofill":"norecord_autofill__2dUJt","spinner":"norecord_spinner__-QQ6Q","loader4":"norecord_loader4__2A1ut","textCenter":"norecord_textCenter__1O-Lc"};